import request from '@/utils/request';

/* 获取课程列表 */
export function getCourse(params) {
    return request({
        url: `/api/course?pageNum=${params.pageNum}&pageSize=${params.pageSize}&type=${params.type}&sort=${params.sort}&parentClassId=${params.parentClassId}&classId=${params.classId}&title=${params.title}&nextClassId=${params.nextClassId}`,
        method: 'get',
        data: params
    })
}

/* 获取课程分类 */
export function getClassify(params) {
    return request({
        url: `/api/courseClassify`,
        method: 'get',
        data: params
    })
}

/* 获取课程章节 */
export function getCourseUnit(params) {
    return request({
        url: `/api/unit?courseId=${params.courseId}`,
        method: 'get',
        data: params
    })
}


/* 获取课程详情 */
export function getCourseDetail(params) {
    return request({
        url: `/api/course/${params.courseId}`,
        method: 'get',
        data: params
    })
}

/* 获取试卷 */
export function getExam(params) {
    return request({
        url: `/api/examination/info?id=${params.id}`,
        method: 'get',
        data: params
    })
}

/* 获取试卷题目 */
export function getExamInfo(params) {
    return request({
        url: `/api/examination/list?id=${params.id}`,
        method: 'get',
        data: params
    })
}

/* 提交考试 */
export function sumbitExamInfo(params) {
    return request({
        url: `/api/examination/submit`,
        method: 'post',
        data: params
    })
}

/* 解锁课程 */
export function unlockCourse(params) {
    return request({
        url: `/api/course`,
        method: 'post',
        data: params
    })
}

/* 更新课程进度 */
export function speedProgress(params) {
    return request({
        url: `/api/speedProgress`,
        method: 'post',
        data: params
    })
}

/* 查询是否解锁课程 */
export function courseCheck(params) {
    return request({
        url: `/api/course/check/${params.courseId}`,
        method: 'get',
        data: params
    })
}

/* 查询在线考试 */
export function examinationOnline(params) {
    return request({
        url: `/api/examination/online?id=${params.id}`,
        method: 'get',
        data: params
    })
}

/* 是否可以考试 */
export function examinationCanExam(params) {
    return request({
        url: `/api/examination/canExam?examId=${params.id}`,
        method: 'get',
        data: params
    })
}











